module.exports = __webpack_public_path__ + "static/media/founder.4abafc5b.jpeg";